import $ from 'jquery';

class puechat {
	constructor() {
      
        this.events();


}


events() {
    $(".delete-note").on("click", this.deleteNote);
    $(".edit-note").on("click", this.editNote);
    
}

//Edit Methords will go here
editNote(e){
  var thisNote = $(e.target).parents("main");
  thisNote.find(".edit-note").html('<i class="fa fa-times" aria-hidden="true"></i>');
  thisNote.find(".note-title-field, .post-text").removeAttr("readonly").addClass("note-active-field");	
  thisNote.find(".update-note").addClass("update-note--visible");	
  
  }

// Delete Methods will go here
deleteNote(e) {
  var thisNote = $(e.target).parents("main")
  $.ajax({
    beforeSend: xhr => {
      xhr.setRequestHeader("X-WP-Nonce", shibliData.nonce)
    },
    url: shibliData.root_url + "/wp-json/wp/v2/puechat/" + thisNote.data("id"),

    type: "DELETE",
    success: response => {
      thisNote.slideUp()
      console.log("Congrats")
      console.log(response)
    },
    error: response => {
      console.log("Sorry")
      console.log(response)
    }
  })
}
}



export default puechat;